import ClassificationCodeComponent from "containers/Form/SimplifiedBuilder/Components/ClassificationCode/ClassificationCodeComponent";

import AnimalProtocolSearch from "./AnimalProtocolSearch";
import BudgetImporterComponent from "./BudgetImporterComponent"; // TODO: Removed and replaced with Summary Budget (08/01/2021). Hidden from Palette with option in component
import COIComponent from "./COIComponent";
import { FundingProgramComponent } from "./FundingProgram";
import HaploCostingTool from "./HaploCostingTool";
import HaploEthicsMonitor from "./HaploEthicsMonitor";
import HaploRepository from "./HaploRepository";
import HazardSafetySearch from "./HazardSafetySearch";
import HumanEthicsStudySearch from "./HumanEthicsStudySearch";
import InformationTextComponent from "./InformationTextComponent";
import PanelComponent from "./PanelComponent";
import { QuestionComponent } from "./Question";
import ResearchTeamBudget from "./ResearchTeamBudgetComponent"; // TODO: Removed and replaced with Summary Budget (08/01/2021). Hidden from Palette with option in component
import ResearchTeamComponent from "./ResearchTeamComponent";
import S2SIntegrationComponent from "./S2SIntegrationComponent";
import SummaryBudgetComponent from "./SummaryBudgetComponent";
import TabsComponent from "./TabsComponent";


const components = {
	panel: PanelComponent,
	tabs: TabsComponent,
	text: QuestionComponent,
	date: QuestionComponent,
	select: QuestionComponent,
	richText: QuestionComponent,
	stringList: QuestionComponent,
	textarea: QuestionComponent,
	number: QuestionComponent,
	radio: QuestionComponent,
	cayuseCheckboxes: QuestionComponent,
	fileInput: QuestionComponent,
	information: QuestionComponent,
	researchTeam: ResearchTeamComponent,
	informationText: InformationTextComponent,
	htmlComponent: InformationTextComponent,
	cayuseResearchTeamBudget: ResearchTeamBudget, // TODO: Removed and replaced with Summary Budget (08/01/2021). Hidden from SFB Palette with option in component
	cayuseCOIComponent: COIComponent,
	cayuseAnimalOversight: AnimalProtocolSearch,
	cayuseHazardSafety: HazardSafetySearch,
	cayuseHaploCostingTool: HaploCostingTool,
	cayuseHaploEthicsMonitor: HaploEthicsMonitor,
	cayuseHaploRepository: HaploRepository,
	cayuseResearchTeamBudgetImporter: BudgetImporterComponent, // TODO: Removed and replaced with Summary Budget (08/01/2021). Hidden from SFB Palette with option in component
	cayuseProposalsS2SRecord: S2SIntegrationComponent,
	cayuseSummaryBudgetImporter: SummaryBudgetComponent,
	cayuseHumanEthicsStudySearch: HumanEthicsStudySearch,
	classificationCodes: ClassificationCodeComponent,
	fundingProgram: FundingProgramComponent,

	// Mapping to flowable's cayuse components
	"person-finder": QuestionComponent,
	"unit-finder": QuestionComponent,
	"org-finder": QuestionComponent,
};

export default components;
